import { lazy } from "react"
import {
  HIVE_MEASUREMENT_DETAIL_VIEW,
  HIVE_MEASUREMENT_LIST_VIEW,
  HIVE_SCALE_VIEW,
  HIVE_SCALE_LIST_VIEW,
} from "@/features/bees/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllHiveScales = lazy(
  () =>
    import(
      "@/features/bees/views/hive-scales/all-hive-scales/all-hive-scales.tsx"
    ),
)
const HiveScaleMeasurementViewDetail = lazy(
  () =>
    import(
      "@/features/bees/views/hive-scales/hive-scale-measurement-view-detail/hive-scale-measurement-view-detail.tsx"
    ),
)
const HiveScaleMeasurementViewList = lazy(
  () =>
    import(
      "@/features/bees/views/hive-scales/hive-scale-measurment-view-list/hive-scale-measurement-view-list.tsx"
    ),
)
const HiveScaleView = lazy(
  () =>
    import(
      "@/features/bees/views/hive-scales/hive-scale-view/hive-scale-view.tsx"
    ),
)
export const hiveScalesRoutes = [
  {
    path: HIVE_SCALE_LIST_VIEW,
    element: <AllHiveScales />,
  },
  {
    path: HIVE_MEASUREMENT_DETAIL_VIEW,
    element: <HiveScaleMeasurementViewDetail />,
  },
  {
    path: HIVE_MEASUREMENT_LIST_VIEW,
    element: <HiveScaleMeasurementViewList />,
  },
  {
    path: HIVE_SCALE_VIEW,
    element: <HiveScaleView />,
  },
]

const DESKTOP_HIVE_SCALES_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: hiveScalesRoutes,
  },
]

const MOBILE_HIVE_SCALES_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: hiveScalesRoutes,
  },
]

export const getHiveScalesRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_HIVE_SCALES_ROUTES : MOBILE_HIVE_SCALES_ROUTES
}
